import CompleteVerification from './CompleteVerification';
import PendingVerification from './PendingVerification';

export default {
  CompleteVerification,
  PendingVerification,
};
